'use es6';

import { http } from '../features/http';
import { TRACK_API_URL } from './TracksApi';
import { LESSON_API_URL } from './LessonsApi';
export function postTrackEngagment(trackId) {
  return http.post(`${TRACK_API_URL}/${trackId}/conversion`);
}
export function postLessonEngagment(lessonId) {
  return http.post(`${LESSON_API_URL}/${lessonId}/conversion`);
}